<p *ngIf="progetto" class="uppercase">
  <a class="underline" href="/progetti">> Progetti </a> <a class="underline" href="/progetti/{{progetto.id}}">>
    {{progetto.nome}}</a> > {{edizione?.nome}}
  <!-- EDIZIONE-->
<div *ngIf="edizione" class="py-4 px-4 bg-white rounded-xl shadow-lg w-full" style="background-color: {{_bgColor}}">
  <div *ngIf="edizione"
    class="inline-grid grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-1 w-full">
    <div class="block">
      <div class="text-left">
        <h2>
          Titolo: <span class="font-semibold text-black">{{edizione.nome}}</span>
        </h2>
        <p class="my-1" *ngIf="progetto">
          Progetto: <span class="font-semibold text-black">{{progetto.nome}}</span>
        </p>
        <p>
          Data: <span class="font-semibold text-black">{{edizione.getEditionDate()}}</span>
        </p>
        <p class="my-1" *ngIf="edizione.descrizione">
          <span class="text-black">{{edizione.descrizione}}</span>
        </p>
        <p class="hidden">
          Stato: <span *ngIf="edizione.status == 0"
            class="font-semibold text-subscription_unconfirmed">chiusa</span><span *ngIf="edizione.status == 1"
            class="font-semibold text-black">aperta</span>
        </p>
        <p class="my-1" *ngIf="iscrizioni">
          iscritti: {{iscrizioni}} <span *ngIf="confermati >0 "> - confermati: {{confermati}}</span> <span
            *ngIf="presenti >0 "> - presenti: {{presenti}}</span>
        </p>
      </div>
    </div>
    <div class="block text-center">
      <app-canvas-badge #badge_component edizione_id="{{edizione.id}}"></app-canvas-badge>
    </div>
  </div>
</div>
<div class="block relative -top-8 w-4">
  <button (click)="openModal()" class="cursor-pointer plus w-3" alt="nuova iscrizione" title="nuova iscrizione">
    <svg xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path
        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
    </svg>
  </button>
</div>
<!-- TOOLBAR -->
<div class="w-full text-left p-1">
  <ul class="inline-flex">
    <li role="button" class="cursor-pointer mx-4 my-2">
      <fa-icon class="svg-faButton" [ngClass]="{'hidden': layoutGrid}" [icon]="faTh"
        (click)="changeLayout($event.target)" title="vista griglia"></fa-icon>
      <fa-icon class="svg-faButton" [ngClass]="{'hidden': !layoutGrid}" [icon]="faList"
        (click)="changeLayout($event.target)" title="vista lista"></fa-icon>
    </li>
    <li role="button" class="cursor-pointer mx-4 my-2" title="stampa badge confermati">
      <fa-icon class="svg-faButton" [icon]="faPrint" (click)="stampaBadges()"></fa-icon>
    </li>
    <li role="button" class="cursor-pointer mx-4 my-2" title="filtro confermati">
      <p (click)="filtroConf()" [ngClass]="{'font-bold': filtroConfermati}">confermati</p>
    </li>
    <li role="button" class="cursor-pointer mx-4 my-2" title="filtro presenti">
      <p (click)="filtroPres()" [ngClass]="{'font-bold': filtroPresenti}">presenti</p>
    </li>
    <li role="button" class="cursor-pointer mx-4 my-2" title="cerca iscritto">
      <fa-icon class="svg-faButton" [icon]="faSearch" (click)="search(this)" class="mr-1"></fa-icon>
      <input type="text" id="search" (keyup.enter)="search(this)" [(ngModel)]="searchText" (ngModelChange)="searchKey()"
        placeholder="Cerca" />
    </li>
    <li role="button" class="cursor-pointer mx-4 my-2">
      <fa-icon class="svg-faButton" [icon]="faUser" (click)="presenza()" title="registra una presenza"></fa-icon>
    </li>
    <li role="button" class="cursor-pointer mx-4 my-2">
      <fa-icon class="svg-faButton" [icon]="faUsers" (click)="presenze()" title="registra lista presenze"></fa-icon>
    </li>
    <li role="button" class="cursor-pointer mx-4 my-2">
      <fa-icon class="svg-faButton" [icon]="faFileExcel" (click)="generateExcel()" title="esporta file excel"></fa-icon>
    </li>
  </ul>

</div>
<!-- ISCRIZIONI-->
<div *ngIf="edizione" class="bg-white" [ngClass]="{'gridL': layoutGrid}">
  <div *ngFor="let iscritto of iscritti; trackBy: trackIscr"
    class="text-slate-800 items-center rounded-md transition-all hover:bg-slate-100 focus:bg-slate-100 active:bg-slate-100 w-full">
    <!--div (click)="openIscrizione(iscritto.id)" -->
    <div>
      <div class="p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
        <div class="inline-grid grid-cols-1 gap-12 w-full">
          <div class="block break-keep text-balance">
            <p class="block">
              nominativo: <span
                class="uppercase mb-2 text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{iscritto.nome}}
                {{iscritto.cognome}}</span>
            </p>
            <p class="text-wrap">
              azienda: {{iscritto.azienda}}
            </p>
            <p class="text-balance cursor-pointer mt-2 underline">
              email: <a href="mailto:{{iscritto.email}}">{{iscritto.email}}
                <fa-icon class="px-2 text-testo" [icon]="faEnvelope" role="button" title="invia e-mail"></fa-icon>
              </a>
            </p>
            <div class="row">
              <div
                class="inline-grid grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 md:grid-cols-2  sm:grid-cols-1 gap-4 w-full mt-2">
                <div class="underline cursor-pointer" (click)="confermaIscrizione(iscritto)"
                  title="conferma iscrizione ed invio badge">
                  confermato: <span class="text-xl text-subscription_confirmed"
                    *ngIf="iscritto.confermata == 1">si</span><span class="text-2xl text-subscription_unconfirmed"
                    *ngIf="iscritto.confermata == 0">no</span>
                </div>
                <div class="underline cursor-pointer" (click)="confermaPresenza(iscritto)"
                  title="conferma iscrizione ed invio badge">
                  <span *ngIf="iscritto.presenza == 1">presente: <span
                      class="text-xl text-subscription_confirmed">si</span></span>
                  <!--span *ngIf="iscritto.presenza != 1">presenza<span class="text-xl text-subscription_confirmed"></span></span !-->
                </div>
              </div>
            </div>
            <p class="mt-2" *ngIf="iscritto.profilo">
              profilo: {{iscritto.profilo}}
            </p>
            <p class="mt-2" *ngIf="iscritto.orario">
              <fa-icon class="svg-faButton" [icon]="faVideo" title="orario Trend Presentation"></fa-icon>
              {{iscritto.orario}}
            </p>
            <p class="ml-0 mt-2 inline-block">
              <fa-icon alt="mostra badge" title="mostra badge" class="cursor-pointer pr-2 text-testo" [icon]="faEye"
                (click)="setIscrittoToBadge(iscritto)" role="button" title="anteprima badge iscrizione"></fa-icon>
              <fa-icon alt="edita iscrizione" title="edita iscrizione" class="cursor-pointer px-2 text-testo"
                [icon]="faPencil" (click)="openIscrizione(iscritto)" role="button"
                title="modifica iscrizione"></fa-icon>
              <fa-icon alt="stampa badge iscrizione" title="stampa badge"
                class="cursor-pointer px-2 text-testo svg-faButton" [icon]="faPrint"
                (click)="stampaBadge(iscritto)"></fa-icon>
            </p>
          </div>
        </div>
      </div>
      <div class="block relative -top-4 w-4 text-right w-full">
        <button (click)="deleteIscritto(iscritto)" class="w-8" alt="cancella iscrizione" title="cancella iscrizione">
          <svg xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
            <path fill="#000000"
              d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- MODAL ISCRIZIONE-->
<!-- Modal container -->
<div *ngIf="isModalOpen"
  class="fixed top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
  <div
    class="relative p w-full max-w-xl md:max-w-2xl bg-white rounded-lg shadow dark:bg-gray-700 max-h-[90vh] overflow-y-auto mx-4 md:mx-0">

    <!-- Modal header -->
    <div *ngIf="!isIscritto()"
      class="sticky top-0 flex items-center justify-between p-4 border-b rounded-t bg-white dark:border-gray-600">
      <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
        <span *ngIf="!isIscritto()">Nuova iscrizione</span>
        <span *ngIf="isIscritto()">Modifica iscrizione</span>
      </h3>
      <button (click)="closeModal()"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
        <!-- Close SVG -->
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
    </div>
    <div *ngIf="isIscritto()"
      class="sticky top-0 flex items-center justify-between p-4 border-b rounded-t bg-white dark:border-gray-600">
      <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
        Iscritto il {{iscritto?.date_created | date}}
      </h3>
      <button (click)="closeModal()"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
        <!-- Close SVG -->
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
    </div>
    <!-- Modal body -->
    <div class="text-center w-full">
      <form class="text-center w-full max-w-sm my-10 space-y-6 inline-block " [formGroup]="form"
        (ngSubmit)="onSubmit()">
        <div class="form__group">
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                Nome
              </label>
            </div>
            <div class="md:w-2/3">
              <input type="text" id="nome" [ngClass]="{ 'is__invalid-input': submitted && f['nome'].errors }"
                placeholder=" " formControlName="nome"
                class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                placeholder="inserisci il nome" formControlName="nome">
            </div>
            <div *ngIf="submitted && f['nome'].errors" class="is__invalid-error">
              <div *ngIf="f['nome'].errors['required']">Campo richiesto</div>
            </div>
          </div>
        </div>
        <div class="form__group">
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                Cognome
              </label>
            </div>
            <div class="md:w-2/3">
              <input type="text" id="cognome" [ngClass]="{ 'is__invalid-input': submitted && f['cognome'].errors }"
                placeholder=" " formControlName="cognome"
                class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                placeholder="inserisci il cognome" formControlName="cognome">
            </div>
            <div *ngIf="submitted && f['cognome'].errors" class="is__invalid-error">
              <div *ngIf="f['cognome'].errors['required']">Campo richiesto</div>
            </div>
          </div>
        </div>
        <div class="form__group">
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                Azienda
              </label>
            </div>
            <div class="md:w-2/3">
              <input type="text" id="azienda" [ngClass]="{ 'is__invalid-input': submitted && f['azienda'].errors }"
                placeholder=" " formControlName="azienda"
                class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                placeholder="inserisci l'azienda" formControlName="azienda">
            </div>
            <div *ngIf="submitted && f['azienda'].errors" class="is__invalid-error">
              <div *ngIf="f['azienda'].errors['required']">Campo richiesto</div>
            </div>
          </div>
        </div>
        <div class="form__group">
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="email">
                Email
              </label>
            </div>
            <div class="md:w-2/3">
              <input type="text" id="email" [ngClass]="{ 'is__invalid-input': submitted && f['email'].errors }"
                placeholder=" " formControlName="email"
                class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                placeholder="inserisci l'e-mail" formControlName="email">
            </div>
            <div *ngIf="submitted && f['email'].errors" class="is__invalid-error">
              <div *ngIf="f['email'].errors['required']">Campo richiesto</div>
              <div *ngIf="f['email'].errors['email']">L'e-mail deve essere un indirizzo valido.</div>
            </div>
          </div>
        </div>
        <div class="form__group">
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                Profilo
              </label>
            </div>
            <div class="md:w-2/3">
              <input type="text" id="profilo" [ngClass]="{ 'is__invalid-input': submitted && f['profilo'].errors }"
                placeholder=" " formControlName="profilo"
                class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                placeholder="inserisci il profilo" formControlName="profilo">
            </div>
          </div>
        </div>
        <div class="inline-grid grid-cols-2 gap-2 w-full">
          <div class="text-center md:items-center">
            <button [hidden]="form.invalid" impact="bold" tone="primary" shape="rounded" size="medium"
              class="shadow focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded">
              <span [hidden]="isIscritto()">Salva</span>
              <span [hidden]="!isIscritto()">Aggiorna</span>
            </button>
          </div>
          <div class="text-center md:items-center">
            <button (click)="closeModal()" impact="bold" tone="primary" shape="rounded" size="medium"
              class="shadow focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded">
              Annulla
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="text-center text-sm color-warning">{{print_error}}</div>
  </div>
</div>
